export var getCounterValue = function getCounterValue(value, maxLength) {
  if (!maxLength) {
    return String(value);
  }
  var maxNumber = Number(Array.from({
    length: maxLength
  }, function () {
    return '9';
  }).join(''));
  return maxNumber > value ? String(value) : "".concat(maxNumber, "+");
};